import React from 'react';
import styled from 'styled-components';
import * as SS from 'styled-system';

import { colors } from 'theme';

const Divider = styled(
  (
    {
      mt,
      mb,
      ml,
      mr,
      mx,
      my,
      pt,
      pb,
      pl,
      pr,
      px,
      py,
      color,
      border,
      opacity,
      borderLeft,
      borderRight,
      borderTop,
      borderBottom,
      borderColor,
      display,
      width,
      dashed,
      light,
      ...props
    } // TODO: Fix this the next time the file is edited.
  ) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <hr {...props} />
  )
)`
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 16px;
  margin-bottom: 16px;
  border: none;
  border-bottom: 1px solid;
  border-color: ${colors.silver};
  ${SS.border} ${SS.borderColor} ${SS.space} ${SS.width} ${SS.color} 
  ${SS.display} ${SS.opacity};
  ${(props) =>
    props.dashed &&
    `
    border-bottom-style: dashed;
  `}
  ${(props) =>
    props.light &&
    `
    border-color: ${colors.aluminum};
  `}
`;
export default Divider;
